/**
 * Created On : 22nd Feb 2018
 * Usage : Displays the more option. This is applicable to only CSD users 
 * Coprights : Johnson Controls India Pvt Ltd.
 **/
import { Component } from '@angular/core';
import { Platform, NavController } from 'ionic-angular';
import { SecurityConfiguration } from '../../security/security.configuration';
import { Storage } from "@ionic/storage";

declare let ga: any;
@Component({
    selector: 'more',
    templateUrl: 'more.html'
})


export class MoreComponent {
    public username:string;
    constructor(
        private platform: Platform,
        private navCtrl: NavController,
        private securityConfig: SecurityConfiguration,
        private storage: Storage,
    ) { }

    ngInit()
    {
        this.storage.get('username').then((username) => {
            this.username = username;
        });
        ga('set', 'title', 'More');
        ga('set', 'page', '/mobile/dashboard/more');
        ga('set', 'dimension1', this.username);
        ga('send', 'pageview');
    }

    redirectToFacility() {
        this.navCtrl.popToRoot();
    }

    logout() {
        if (this.platform.is("mobileweb") || this.platform.is("core")) {
            this.securityConfig.logout();
        }
    }

    downloadHelpDocument(){
        let xhr = new XMLHttpRequest();
        xhr.open("GET", "assets/imgs/helpdoc.pdf");
        xhr.responseType = "blob";
        xhr.onload = function() {
            let file = new Blob([xhr.response], { 
                type: 'application/pdf' 
            });
            let url = URL.createObjectURL(file);
            let a = document.createElement('a');
            a.href = url, a.download = "CEP_Mobile_User_Guid.pdf";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        };
        
        xhr.send(null);
    }
}



// WEBPACK FOOTER //
// ./src/components/more/more.component.ts